// @flow

import React, { useEffect } from 'react'
import { AnimatedSwitch } from 'react-router-transition'
import { withRouter } from 'react-router-dom'
import type { RouterHistory } from 'react-router'
import './index.css'

type Props = {
  children: React$Element,
  history: RouterHistory,
}

function pageTransitions(action) {
  return {
    atEnter: {
      offset: action === 'PUSH' ? 600 : -600,
      opacity: 1,
    },
    atLeave: {
      offset: action === 'PUSH' ? -600 : 600,
      opacity: 0,
    },
    atActive: {
      offset: 0,
      opacity: 1,
    },
  }
}

const mapStyles = styles => ({
  opacity: styles.opacity,
  transform: `translateX(${styles.offset}px)`,
})

export function AnimatedSwitchPagination(props: Props) {
  useEffect(() => {
    window.scrollTo(0, 0)
  })

  return (
    <AnimatedSwitch
      className="switch-wrapper"
      runOnMount={location.pathname === '/'}
      {...pageTransitions(props.history.action)}
      mapStyles={mapStyles}
      data-test-id="pagination-container"
    >
      {props.children}
    </AnimatedSwitch>
  )
}

export default withRouter(AnimatedSwitchPagination)
